import React, {useState, useEffect} from 'react'
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from 'react-router-dom';

const PaginationControl = ({page, count, url}) => {

    const [label, setLabel] = useState("");
    const [isPrev, setIsPrev] = useState(false);
    const [isNext, setIsNext] = useState(false);
    const [prevHover, setPrevHover] = useState(false);
    const [nextHover, setNextHover] = useState(false);

    useEffect(()=>{
        presetControl();
    }, []);

    function presetControl(){
        const lb = `Page ${page} of ${count.PageCount}`;
        setLabel(lb);
        if(page > 1){
            setIsPrev(true);
        }
        if(page < parseInt(count.PageCount)){
            setIsNext(true);
        }
        if(page > count.PageCount){
            setIsNext(false);
            page = count.PageCount
        }
    }

    const prevBtnHover = (entered) => {
        setPrevHover(entered);
    };

    const nextBtnHover = (entered) => {
        setNextHover(entered);
    };

    function paginate(direction){
        const newPage = (direction == "prev")? (parseInt(page) - 1): (parseInt(page) + 1);
        window.location = `${url}/${newPage}`;
    }

    const styles = {
        pagination: {
            display: 'flex'
        },
        label:{
            color: '#777',
            marginRight: 30
        },
        prevBtn: {
            background: prevHover?'#deedf4':'#efefef',
            color: prevHover?'#0033ff':'#007bff',
            padding: '1px 15px',
            border: 'none',
            marginRight: 10
        },
        nextBtn: {
            background: nextHover?'#deedf4':'#efefef',
            color: nextHover?'#0033ff':'#007bff',
            padding: '3px 15px',
            border: 'none',
            marginRight: 10
        },
    }

    return (
        <div style={styles.pagination}>
            <div style={styles.label}>{label}</div>
            <button 
                onClick={()=>paginate("prev")} 
                style={styles.prevBtn} 
                disabled={isPrev?"":"disabled"}
                onMouseEnter={()=>prevBtnHover(true)} 
                onMouseLeave={()=>prevBtnHover(false)}
            >
                <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            <button 
                onClick={()=>paginate("next")} 
                style={styles.nextBtn} 
                disabled={isNext?"":"disabled"}
                onMouseEnter={()=>nextBtnHover(true)} 
                onMouseLeave={()=>nextBtnHover(false)}
            >
                <FontAwesomeIcon icon={faChevronRight} />
            </button>
        </div>
    )
}

export default PaginationControl